/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { ReadAlertResponseDtoAction } from './readAlertResponseDtoAction';
import type { UserSummaryDto } from './userSummaryDto';

export interface ReadAlertResponseDto {
  /** Alert ID */
  id: string;
  /** Alert action */
  action: ReadAlertResponseDtoAction;
  /** Whether the alert has been read */
  read: boolean;
  /** User who received the alert */
  user: UserSummaryDto;
  /** Creation date */
  createdAt: string;
  /** Last update date */
  updatedAt: string;
}
